import React from "react";
const style7 = {
  fill: "#fff",
  background: "linear-gradient(45deg, #3858f9, #8e79fd)",
  padding: "11px",
  borderRadius: "5px",
  boxShadow: "0 7px 30px rgba(128, 116, 252, 0.5)",
};
const style8 = {
  fill: "#fff",
  background: "linear-gradient(to top, #0ba360 0%, #3cba92 100%)",
  padding: "11px",
  borderRadius: "5px",
  boxShadow: "0 7px 30px rgba(11, 163, 96, 0.3)",
};
const style9 = {
  fill: "#fff",
  background: "linear-gradient(45deg, #f53c5b, #fb768c)",
  padding: "11px",
  borderRadius: "5px",
  boxShadow: "0 7px 30px rgba(250, 106, 130, 0.5)",
};
const style10 = {
  fill: "#fff",
  background: "linear-gradient(45deg, #ff5858 0%, #f09819 100%)",
  padding: "11px",
  borderRadius: "5px",
  boxShadow: "0 7px 30px rgba(241, 159, 93, 0.5)",
};
const style1 = {
  fill: "#fff",
  background: "linear-gradient(45deg, #1071a6  0%, #44b3cf 100%)",
  padding: "11px",
  borderRadius: "5px",
  boxShadow: "0 5px 10px rgba(93,191,220,255)",
};
const style6 = {
  fill: "#fff",
  background: "linear-gradient(45deg, #c48b76  0%, #f2c27d)",
  borderRadius: "5px",
  boxShadow: "0 5px 10px rgba(187, 123, 100)",
};
const style3 = {
  fill: "#fff",
  background: "linear-gradient(45deg, #b610c2  0%, #da59e4)",
  borderRadius: "5px",
  boxShadow: "0 5px 10px rgba(202, 18, 216, 1)",
};
const style4 = {
  fill: "#fff",
  background: "linear-gradient(45deg, #00b39e  0%, #00e6cb)",
  borderRadius: "5px",
  boxShadow: "0 3px 7px rgba(0, 255, 225, 100)",
};
const style5 = {
  fill: "#fff",
  background: "linear-gradient(45deg, #008be8  0%, #39b0ff)",
  borderRadius: "5px",
  boxShadow: "0 3px 7px rgba(0,9, 105, 170)",
};
const style2 = {
  fill: "#fff",
  background: "linear-gradient(45deg, #692cbc  0%, #8947e2)",
  borderRadius: "5px",
  boxShadow: "0 3px 7px rgba(137, 71, 226)",
};
const style11 = {
  fill: "#fff",
  background: "linear-gradient(45deg, rgb(255 150 0), rgb(255 157 0))",
  borderRadius: "5px",
  boxShadow: "rgb(255 176 0 / 50%) 0px 7px 30px",
};
const Icons = (props) => {
  if (props.group_id === 11)
    return (
      <svg
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 489.2 489.2"
        className="mr-4 ht-60 wd-60 my-auto primary"
        style={style11}
        xmlSpace="preserve"
      >
        <g>
          <g>
            <g>
              <path
                d="M49.4,118.85v227.5h350v-78.3h49.4v91.9c0,20-16.2,36.2-36.2,36.2H264.9v40.5h28.8c4.8,0,8.7,3.9,8.7,8.7v25.2
              c0,4.8-3.9,8.7-8.7,8.7H155c-4.8,0-8.7-3.9-8.7-8.7v-25.2c0-4.8,3.9-8.7,8.7-8.7h28.8v-40.4H36.2c-20,0-36.2-16.2-36.2-36.2
              v-254.4c0-20,16.2-36.2,36.2-36.2h131.6v49.4L49.4,118.85L49.4,118.85z M244.1,273.95v-46.8h-6.5c-16.1,0-29.1-13-29.1-29.1v-159
              c0-16.1,13-29.1,29.1-29.1h222.5c16.1,0,29.1,13,29.1,29.1v159c0,16.1-13,29.1-29.1,29.1h-159l-49.8,49.8
              C248.7,279.65,244.1,277.75,244.1,273.95z M384.2,118.55c0,8.4,6.8,15.1,15.1,15.1c8.4,0,15.1-6.8,15.1-15.1
              c0-8.4-6.8-15.1-15.1-15.1C391,103.45,384.2,110.25,384.2,118.55z M333.8,118.55c0,8.4,6.8,15.1,15.1,15.1
              c8.4,0,15.1-6.8,15.1-15.1c0-8.4-6.8-15.1-15.1-15.1C340.6,103.45,333.8,110.25,333.8,118.55z M283.4,118.55
              c0,8.4,6.8,15.1,15.1,15.1c8.4,0,15.1-6.8,15.1-15.1c0-8.4-6.8-15.1-15.1-15.1C290.2,103.45,283.4,110.25,283.4,118.55z"
              />
            </g>
          </g>
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
      </svg>
    );
  if (props.group_id === 9)
    return (
      <svg
        enableBackground="new 0 0 469.682 469.682"
        version="1.1"
        className="mr-4 ht-60 wd-60 my-auto primary"
        style={style1}
        viewBox="0 0 499.68 499.68"
        xmlSpace="preserve"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M336 264.13V436c0 24.3-19.05 44-42.95 44H107c-23.95 0-43-19.7-43-44V172a44.26 44.26 0 0144-44h94.12a24.55 24.55 0 0117.49 7.36l109.15 111a25.4 25.4 0 017.24 17.77z"
          fill="none"
          stroke="white"
          strokeLinejoin="round"
          strokeWidth={24}
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M200 128v108a28.34 28.34 0 0028 28h108"
          fill="none"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={24}
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M176 128V76a44.26 44.26 0 0144-44h94a24.83 24.83 0 0117.61 7.36l109.15 111A25.09 25.09 0 01448 168v172c0 24.3-19.05 44-42.95 44H344"
          fill="none"
          stroke="white"
          strokeLinejoin="round"
          strokeWidth={24}
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M312 32v108a28.34 28.34 0 0028 28h108"
          fill="none"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={24}
        />
      </svg>
    );
  if (props.group_id === 1)
    return (
      <svg
        version="1.1"
        id="Layer_1"
        className="mr-4 ht-60 wd-60 my-auto primary"
        xmlSpace="preserve"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 480 480"
        style={style9}
      >
        <g>
          <g>
            <g>
              <path
                d="M240,0C107.664,0,0,107.664,0,240s107.664,240,240,240s240-107.664,240-240S372.336,0,240,0z M240,460
c-121.309,0-220-98.691-220-220S118.691,20,240,20s220,98.691,220,220S361.309,460,240,460z"
              />
              <path
                d="M410,194.999h-27.058c-2.643-8.44-6-16.56-10.03-24.271l19.158-19.158c3.776-3.775,5.854-8.79,5.854-14.121
c0-5.332-2.08-10.347-5.854-14.121l-35.399-35.399c-3.775-3.775-8.79-5.854-14.122-5.854c-5.331,0-10.346,2.079-14.121,5.854
l-19.158,19.158c-7.711-4.03-15.832-7.386-24.271-10.03V70c0-11.028-8.972-20-20-20h-50c-11.028,0-20,8.972-20,20v27.058
c-8.44,2.643-16.56,6-24.271,10.03L151.57,87.93c-3.775-3.776-8.79-5.854-14.121-5.854c-5.332,0-10.347,2.08-14.121,5.854
l-35.399,35.399c-3.775,3.775-5.854,8.79-5.854,14.122c0,5.331,2.079,10.346,5.854,14.121l19.158,19.158
c-4.03,7.711-7.386,15.832-10.03,24.271H70c-11.028,0-20,8.972-20,20v50c0,11.028,8.972,20,20,20h27.057
c2.643,8.44,6,16.56,10.03,24.271L87.929,328.43c-3.776,3.775-5.854,8.79-5.854,14.121c0,5.332,2.08,10.347,5.854,14.121
l35.399,35.399c3.775,3.775,8.79,5.854,14.122,5.854c5.331,0,10.346-2.079,14.121-5.854l19.158-19.158
c7.711,4.03,15.832,7.386,24.271,10.03V410c0,11.028,8.972,20,20,20h50c11.028,0,20-8.972,20.001-20v-27.058
c8.44-2.643,16.56-6,24.271-10.03l19.158,19.158c3.775,3.776,8.79,5.854,14.121,5.854c5.332,0,10.347-2.08,14.121-5.854
l35.399-35.399c3.775-3.775,5.854-8.79,5.854-14.122c0-5.331-2.079-10.346-5.854-14.121l-19.158-19.158
c4.03-7.711,7.386-15.832,10.03-24.271H410c11.028,0,20-8.972,20-20v-50C430,203.971,421.028,194.999,410,194.999z M410,264.998
h-34.598c-4.562,0-8.544,3.086-9.684,7.503c-3.069,11.901-7.716,23.133-13.813,33.387c-2.337,3.931-1.71,8.948,1.524,12.182
l24.5,24.457l-35.357,35.4l-24.5-24.5c-3.236-3.235-8.253-3.86-12.182-1.524c-10.254,6.097-21.487,10.745-33.387,13.813
c-4.417,1.14-7.503,5.122-7.503,9.684V410h-50v-34.599c0-4.562-3.086-8.544-7.503-9.684
c-11.901-3.069-23.133-7.716-33.387-13.813c-1.587-0.944-3.353-1.404-5.107-1.404c-2.586,0-5.147,1.002-7.073,2.931l-24.457,24.5
l-35.4-35.357l24.5-24.5c3.234-3.235,3.861-8.251,1.524-12.182c-6.097-10.254-10.745-21.487-13.813-33.387
c-1.14-4.417-5.122-7.503-9.684-7.503H70v-50h34.596c4.562,0,8.544-3.086,9.684-7.503c3.069-11.901,7.716-23.133,13.813-33.387
c2.337-3.931,1.71-8.948-1.524-12.182l-24.5-24.457l35.357-35.4l24.5,24.5c3.236,3.235,8.253,3.861,12.182,1.524
c10.254-6.097,21.487-10.745,33.387-13.813c4.417-1.14,7.503-5.122,7.503-9.684V70h50v34.596c0,4.562,3.086,8.544,7.503,9.684
c11.901,3.069,23.133,7.716,33.387,13.813c3.929,2.337,8.947,1.709,12.182-1.524l24.457-24.5l35.4,35.357l-24.5,24.5
c-3.234,3.235-3.861,8.251-1.524,12.182c6.097,10.254,10.745,21.487,13.813,33.387c1.14,4.417,5.122,7.503,9.684,7.503H410
V264.998z"
              />
              <path
                d="M331.585,292.475l-40-35l-13.17,15.051L298.386,290H240c-27.57,0-50-22.43-50-50h-20c0,38.598,31.402,70,70,70h58.386
l-19.971,17.475l13.17,15.051l40-35c2.17-1.898,3.415-4.642,3.415-7.525S333.755,294.373,331.585,292.475z"
              />
              <path
                d="M201.585,207.473L181.614,190H240c27.57,0,50,22.43,50,50h20c0-38.598-31.402-70-70-70h-58.386l19.971-17.475
l-13.17-15.051l-40,35c-2.17,1.898-3.415,4.642-3.415,7.525s1.245,5.627,3.415,7.525l40,35L201.585,207.473z"
              />
            </g>
          </g>
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
      </svg>
    );
  if (props.group_id === 2)
    return props.id !== 115 ? (
      <svg
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 489.2 489.2"
        className="mr-4 ht-60 wd-60 my-auto primary"
        style={style2}
        xmlSpace="preserve"
      >
        <g>
          <g>
            <g>
              <path
                d="M49.4,118.85v227.5h350v-78.3h49.4v91.9c0,20-16.2,36.2-36.2,36.2H264.9v40.5h28.8c4.8,0,8.7,3.9,8.7,8.7v25.2
              c0,4.8-3.9,8.7-8.7,8.7H155c-4.8,0-8.7-3.9-8.7-8.7v-25.2c0-4.8,3.9-8.7,8.7-8.7h28.8v-40.4H36.2c-20,0-36.2-16.2-36.2-36.2
              v-254.4c0-20,16.2-36.2,36.2-36.2h131.6v49.4L49.4,118.85L49.4,118.85z M244.1,273.95v-46.8h-6.5c-16.1,0-29.1-13-29.1-29.1v-159
              c0-16.1,13-29.1,29.1-29.1h222.5c16.1,0,29.1,13,29.1,29.1v159c0,16.1-13,29.1-29.1,29.1h-159l-49.8,49.8
              C248.7,279.65,244.1,277.75,244.1,273.95z M384.2,118.55c0,8.4,6.8,15.1,15.1,15.1c8.4,0,15.1-6.8,15.1-15.1
              c0-8.4-6.8-15.1-15.1-15.1C391,103.45,384.2,110.25,384.2,118.55z M333.8,118.55c0,8.4,6.8,15.1,15.1,15.1
              c8.4,0,15.1-6.8,15.1-15.1c0-8.4-6.8-15.1-15.1-15.1C340.6,103.45,333.8,110.25,333.8,118.55z M283.4,118.55
              c0,8.4,6.8,15.1,15.1,15.1c8.4,0,15.1-6.8,15.1-15.1c0-8.4-6.8-15.1-15.1-15.1C290.2,103.45,283.4,110.25,283.4,118.55z"
              />
            </g>
          </g>
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
      </svg>
    ) : (
      <svg
        enableBackground="new 0 0 438.891 438.891"
        className="mr-4 ht-60 wd-60 my-auto danger"
        version="1.1"
        viewBox="0 0 438.89 438.89"
        xmlSpace="preserve"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="m347.97 57.503h-39.706v-17.763c0-5.747-6.269-8.359-12.016-8.359h-30.824c-7.314-20.898-25.6-31.347-46.498-31.347-20.668-0.777-39.467 11.896-46.498 31.347h-30.302c-5.747 0-11.494 2.612-11.494 8.359v17.763h-39.707c-23.53 0.251-42.78 18.813-43.886 42.318v299.36c0 22.988 20.898 39.706 43.886 39.706h257.04c22.988 0 43.886-16.718 43.886-39.706v-299.36c-1.106-23.506-20.356-42.068-43.886-42.319zm-196.44-5.224h28.735c5.016-0.612 9.045-4.428 9.927-9.404 3.094-13.474 14.915-23.146 28.735-23.51 13.692 0.415 25.335 10.117 28.212 23.51 0.937 5.148 5.232 9.013 10.449 9.404h29.78v41.796h-135.84v-41.796zm219.43 346.91c0 11.494-11.494 18.808-22.988 18.808h-257.04c-11.494 0-22.988-7.314-22.988-18.808v-299.36c1.066-11.964 10.978-21.201 22.988-21.42h39.706v26.645c0.552 5.854 5.622 10.233 11.494 9.927h154.12c5.98 0.327 11.209-3.992 12.016-9.927v-26.646h39.706c12.009 0.22 21.922 9.456 22.988 21.42v299.36z" />
        <path d="m179.22 233.57c-3.919-4.131-10.425-4.364-14.629-0.522l-33.437 31.869-14.106-14.629c-3.919-4.131-10.425-4.363-14.629-0.522-4.047 4.24-4.047 10.911 0 15.151l21.42 21.943c1.854 2.076 4.532 3.224 7.314 3.135 2.756-0.039 5.385-1.166 7.314-3.135l40.751-38.661c4.04-3.706 4.31-9.986 0.603-14.025-0.19-0.211-0.391-0.412-0.601-0.604z" />
        <path d="m329.16 256.03h-120.16c-5.771 0-10.449 4.678-10.449 10.449s4.678 10.449 10.449 10.449h120.16c5.771 0 10.449-4.678 10.449-10.449s-4.678-10.449-10.449-10.449z" />
        <path d="m179.22 149.98c-3.919-4.131-10.425-4.364-14.629-0.522l-33.437 31.869-14.106-14.629c-3.919-4.131-10.425-4.364-14.629-0.522-4.047 4.24-4.047 10.911 0 15.151l21.42 21.943c1.854 2.076 4.532 3.224 7.314 3.135 2.756-0.039 5.385-1.166 7.314-3.135l40.751-38.661c4.04-3.706 4.31-9.986 0.603-14.025-0.19-0.211-0.391-0.412-0.601-0.604z" />
        <path d="m329.16 172.44h-120.16c-5.771 0-10.449 4.678-10.449 10.449s4.678 10.449 10.449 10.449h120.16c5.771 0 10.449-4.678 10.449-10.449s-4.678-10.449-10.449-10.449z" />
        <path d="m179.22 317.16c-3.919-4.131-10.425-4.363-14.629-0.522l-33.437 31.869-14.106-14.629c-3.919-4.131-10.425-4.363-14.629-0.522-4.047 4.24-4.047 10.911 0 15.151l21.42 21.943c1.854 2.076 4.532 3.224 7.314 3.135 2.756-0.039 5.385-1.166 7.314-3.135l40.751-38.661c4.04-3.706 4.31-9.986 0.603-14.025-0.19-0.21-0.391-0.411-0.601-0.604z" />
        <path d="m329.16 339.63h-120.16c-5.771 0-10.449 4.678-10.449 10.449s4.678 10.449 10.449 10.449h120.16c5.771 0 10.449-4.678 10.449-10.449s-4.678-10.449-10.449-10.449z" />
      </svg>
    );
  if (props.group_id === 4)
    return props.id === 120 ? (
      <svg
        enableBackground="new 0 0 477.849 477.849"
        className="mr-4 ht-60 wd-60 my-auto success"
        style={style4}
        version="1.1"
        viewBox="0 0 477.85 477.85"
        xmlSpace="preserve"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="m374.1 385.52c71.682-74.715 69.224-193.39-5.492-265.08-34.974-33.554-81.584-52.26-130.05-52.193-103.54-0.144-187.59 83.676-187.74 187.22-0.067 48.467 18.639 95.077 52.193 130.05l-48.777 65.024c-5.655 7.541-4.127 18.238 3.413 23.893s18.238 4.127 23.893-3.413l47.275-63.044c65.4 47.651 154.08 47.651 219.48 0l47.275 63.044c5.655 7.541 16.353 9.069 23.893 3.413 7.541-5.655 9.069-16.353 3.413-23.893l-48.775-65.024zm-135.54 24.064c-84.792-0.094-153.51-68.808-153.6-153.6 0-84.831 68.769-153.6 153.6-153.6s153.6 68.769 153.6 153.6-68.769 153.6-153.6 153.6z" />
        <path d="m145.29 24.984c-33.742-32.902-87.767-32.221-120.67 1.521-32.314 33.139-32.318 85.997-8e-3 119.14 6.665 6.663 17.468 6.663 24.132 0l96.546-96.529c6.663-6.665 6.663-17.468 0-24.133zm-106.55 82.398c-12.186-25.516-1.38-56.08 24.136-68.267 13.955-6.665 30.175-6.665 44.131 0l-68.267 68.267z" />
        <path d="m452.49 24.984c-33.323-33.313-87.339-33.313-120.66 0-6.663 6.665-6.663 17.468 0 24.132l96.529 96.529c6.665 6.663 17.468 6.663 24.132 0 33.313-33.322 33.313-87.338 0-120.66zm-14.08 82.449-68.301-68.301c19.632-9.021 42.79-5.041 58.283 10.018 15.356 15.341 19.371 38.696 10.018 58.283z" />
        <path d="m238.56 136.52c-9.426 0-17.067 7.641-17.067 17.067v96.717l-47.787 63.71c-5.655 7.541-4.127 18.238 3.413 23.893s18.238 4.127 23.893-3.413l51.2-68.267c2.216-2.954 3.413-6.547 3.413-10.24v-102.4c1e-3 -9.426-7.64-17.067-17.065-17.067z" />
      </svg>
    ) : (
      <svg
        version="1.1"
        id="Capa_1"
        className="mr-4 ht-60 wd-60 my-auto primary"
        style={style4}
        viewBox="0 0 410.68 420.68"
        xmlSpace="preserve"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
      >
        <g>
          <path
            d="M90.725,199.067c19.228,0,37.637-5.991,53.237-17.326c16.041-11.654,26.817-26.486,32.945-45.345
             c0.001-0.003,0.001-0.006,0.003-0.009c3.066-9.446,4.436-18.087,4.436-28.016c0-50.006-40.684-90.689-90.689-90.689
             c-19.828,0-37.265,5.666-53.306,17.32c-40.456,29.392-49.456,86.219-20.063,126.675C34.297,185.09,61.75,199.067,90.725,199.067z
              M141.024,164.936l-21.952-30.214l-8.78-12.085l49.726,16.157C155.639,149.079,149.452,157.595,141.024,164.936z M166.346,108.371
             c0,5.79-0.526,10.913-1.703,16.154l-66.486-21.603V33.05C136.386,36.826,166.346,69.165,166.346,108.371z M46.167,47.137
             c11.504-8.358,23.412-12.932,36.989-14.133v75.367c0,0.391,0.031,0.781,0.092,1.167c0.001,0.006,0.002,0.012,0.003,0.018
             c0.028,0.173,0.082,0.337,0.121,0.506c0.048,0.205,0.083,0.413,0.148,0.614c0.002,0.007,0.005,0.015,0.007,0.022
             c0.07,0.214,0.168,0.414,0.257,0.62c0.063,0.147,0.11,0.3,0.185,0.444c0.002,0.005,0.005,0.011,0.008,0.016
             c0.179,0.351,0.385,0.686,0.615,1.004l44.271,60.936c-11.566,6.79-24.611,10.348-38.139,10.348
             c-24.188,0-47.105-11.666-61.303-31.206C4.891,119.095,12.404,71.668,46.167,47.137z"
          />
          <path
            d="M242.589,213.182h40.41c4.143,0,7.5-3.358,7.5-7.5v-180.5c0-4.142-3.357-7.5-7.5-7.5h-40.41c-4.143,0-7.5,3.358-7.5,7.5
             v180.5C235.089,209.824,238.447,213.182,242.589,213.182z M250.089,32.682h25.41v165.5h-25.41V32.682z"
          />
          <path
            d="M307.246,213.182h40.411c4.143,0,7.5-3.358,7.5-7.5v-89.288c0-4.142-3.357-7.5-7.5-7.5h-40.411c-4.143,0-7.5,3.358-7.5,7.5
             v89.288C299.746,209.824,303.103,213.182,307.246,213.182z M314.746,123.894h25.411v74.288h-25.411V123.894z"
          />
          <path
            d="M412.313,66.944h-40.41c-4.143,0-7.5,3.358-7.5,7.5v131.238c0,4.142,3.357,7.5,7.5,7.5h40.41c4.143,0,7.5-3.358,7.5-7.5
             V74.444C419.813,70.302,416.456,66.944,412.313,66.944z M404.813,198.182h-25.41V81.944h25.41V198.182z"
          />
          <path
            d="M406.425,288.054c-6.48,0-11.731,5.252-11.731,11.732c0,0.579,0.056,1.144,0.137,1.701l-65.393,77.246
             c-0.402-0.042-0.811-0.065-1.224-0.065c-0.478,0-0.946,0.037-1.409,0.093l-64.564-51.363c-0.759-5.045-4.722-9.028-9.757-9.819
             l-65.708-77.615c0-0.04,0.006-0.079,0.006-0.12c0-6.48-5.252-11.732-11.731-11.732c-5.717,0-10.473,4.091-11.514,9.503
             l-61.594,40.687c-1.373-0.564-2.875-0.88-4.451-0.88c-1.847,0-3.587,0.439-5.141,1.198l-59.471-23.513
             c-1.655-4.472-5.945-7.666-10.993-7.666c-6.479,0-11.731,5.252-11.731,11.732c0,6.479,5.252,11.732,11.731,11.732
             c2.187,0,4.226-0.609,5.977-1.65l58.339,23.066c1.384,4.939,5.907,8.565,11.288,8.565c5.621,0,10.314-3.957,11.459-9.236
             l61.874-40.872c1.313,0.508,2.733,0.797,4.226,0.797c0.605,0,1.195-0.06,1.775-0.149l62.691,74.053
             c-0.381,1.157-0.595,2.389-0.595,3.674c0,6.479,5.253,11.732,11.731,11.732c1.291,0,2.53-0.216,3.691-0.602l62.17,49.459
             c-0.012,0.219-0.033,0.435-0.033,0.657c0,6.479,5.252,11.732,11.732,11.732s11.731-5.252,11.731-11.732
             c0-0.275-0.022-0.544-0.041-0.815l66.105-78.088c0.139,0.005,0.275,0.021,0.415,0.021c6.479,0,11.731-5.252,11.731-11.731
             C418.157,293.306,412.905,288.054,406.425,288.054z"
          />
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
      </svg>
    );
  if (props.group_id === 3)
    return (
      <svg
        enableBackground="new 0 0 469.682 469.682"
        version="1.1"
        className="mr-4 ht-60 wd-60 my-auto primary"
        style={style3}
        viewBox="0 0 569.68 569.68"
        xmlSpace="preserve"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M16,0H8C6.9,0 6,.9 6,2V18C6,19.1 6.9,20 8,20H20C21.1,20 22,19.1 22,18V6L16,0M20,18H8V2H15V7H20V18M4,4V22H20V24H4C2.9,24 2,23.1 2,22V4H4M10,10V12H18V10H10M10,14V16H15V14H10Z"
        />
        <path
          d="M376 144c-3.92 52.87-44 96-88 96s-84.15-43.12-88-96c-4-55 35-96 88-96s92 42 88 96z"
          fill="none"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={32}
        />
        <path
          d="M288 304c-87 0-175.3 48-191.64 138.6-2 10.92 4.21 21.4 15.65 21.4H464c11.44 0 17.62-10.48 15.65-21.4C463.3 352 375 304 288 304z"
          fill="none"
          stroke="white"
          strokeMiterlimit={10}
          strokeWidth={32}
        />
        <path
          fill="none"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={32}
          d="M88 176v112M144 232H32"
        />
      </svg>
    );
  if (props.group_id === 8)
    return props.id !== 123 ? (
      <svg
        enableBackground="new 0 0 469.682 469.682"
        version="1.1"
        className="mr-4 ht-60 wd-60 my-auto primary"
        style={style8}
        viewBox="0 0 499.68 499.68"
        xmlSpace="preserve"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M336 264.13V436c0 24.3-19.05 44-42.95 44H107c-23.95 0-43-19.7-43-44V172a44.26 44.26 0 0144-44h94.12a24.55 24.55 0 0117.49 7.36l109.15 111a25.4 25.4 0 017.24 17.77z"
          fill="none"
          stroke="white"
          strokeLinejoin="round"
          strokeWidth={24}
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M200 128v108a28.34 28.34 0 0028 28h108"
          fill="none"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={24}
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M176 128V76a44.26 44.26 0 0144-44h94a24.83 24.83 0 0117.61 7.36l109.15 111A25.09 25.09 0 01448 168v172c0 24.3-19.05 44-42.95 44H344"
          fill="none"
          stroke="white"
          strokeLinejoin="round"
          strokeWidth={24}
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M312 32v108a28.34 28.34 0 0028 28h108"
          fill="none"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={24}
        />
      </svg>
    ) : (
      <svg
        enableBackground="new 0 0 438.891 438.891"
        className="mr-4 ht-60 wd-60 my-auto danger"
        style={style8}
        version="1.1"
        viewBox="0 0 588.89 568.89"
        xmlSpace="preserve"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M594.091,449.218c0-28.092-3.916-55.873-11.639-82.57l-2.135-7.378h-21.596c-2.017-53.107-19.754-103.45-51.611-146.173
c-31.63-42.419-76.247-74.823-126.108-91.72l2.366-32.94l-8.076-2.226c-25.374-6.994-51.697-10.54-78.239-10.54
c-26.54,0-52.864,3.546-78.238,10.54l-8.077,2.226l2.366,32.94c-49.866,16.896-94.488,49.301-126.12,91.72
C55.125,255.818,37.387,306.161,35.37,359.27H13.773l-2.135,7.378C3.916,393.345,0,421.126,0,449.218v10.217h137.393l38.525,58.986
h242.256l38.525-58.986h137.393V449.218z M490.728,225.312c29.206,39.167,45.537,85.287,47.542,133.958H363.919l15.566-216.763
C423.416,158.515,462.626,187.624,490.728,225.312z M297.053,96.105c21.897,0,43.63,2.592,64.723,7.711L343.432,359.27h-92.756
L232.33,103.816C253.423,98.697,275.157,96.105,297.053,96.105z M103.365,225.312c28.105-37.688,67.32-66.797,111.257-82.807
l15.568,216.764H55.821C57.827,310.598,74.158,264.478,103.365,225.312z M407.113,497.986H186.978L161.8,459.435h270.491
L407.113,497.986z M20.62,439.001c0.732-20.109,3.623-39.985,8.626-59.296h535.599c5.004,19.311,7.894,39.187,8.625,59.296H20.62z"
          strokeWidth={40}
        />
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
      </svg>
    );
  if (props.group_id === 5)
    return (
      <svg
        width="512px"
        height="512px"
        viewBox="0 0 512 512"
        className="mr-4 ht-60 wd-60 my-auto primary"
        style={style5}
        xmlSpace="preserve"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="#fff"
          d="M287.03 20c-39.133.48-79.73 15.297-117 45.938h80.47v43.188c52.76-29.75 114.592-31.588 163.938.03l-18.188 9.72 64.688 50.72-3.75-83.314-26.407 14.126C395.99 48.792 345.038 20.644 290.907 20c-1.288-.015-2.583-.016-3.875 0zm-268 64.625v212.75h212.782V84.625H19.032zm50.282 26.03H205.78v138.939h-18.718v-120.25H69.313v-18.688zm3.344 38.126l90.094 91.845-13.344 13.094-90.094-91.845 13.344-13.094zm206.656 61.75v212.782h212.75v-212.78h-212.75zm50.25 26.064h136.469V375.5h-18.686V255.28h-117.78l-.002-18.686zm3.344 38.094l90.125 91.875-13.342 13.062-90.125-91.844 13.343-13.092zm-278.53 63.656l3.75 83.312 23.312-12.47c60.927 88.637 169.99 106.485 259.625 32.814h-80.439v-43.188c-52.08 29.38-113 31.544-162.03 1.188l20.436-10.938-64.655-50.718z"
        />
      </svg>
    );
  if (props.group_id === 6)
    return (
      <svg
        version="1.1"
        id="Capa_1"
        x="0px"
        y="0px"
        width="24.352px"
        height="24.352px"
        viewBox="0 0 24.352 24.352"
        className="mr-4 ht-60 wd-60 my-auto primary"
        style={style6}
        xmlSpace="preserve"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path
              d="M5.402,3.676c0.399,0,0.726-0.337,0.726-0.75V0.75C6.128,0.337,5.802,0,5.402,0S4.676,0.337,4.676,0.75v2.176
			C4.676,3.339,5.002,3.676,5.402,3.676z"
            />
            <path
              d="M8.788,3.676c0.399,0,0.726-0.337,0.726-0.75V0.75C9.514,0.337,9.188,0,8.788,0c-0.4,0-0.726,0.337-0.726,0.75v2.176
			C8.063,3.339,8.389,3.676,8.788,3.676z"
            />
            <path
              d="M12.176,3.676c0.399,0,0.726-0.337,0.726-0.75V0.75c0-0.413-0.326-0.75-0.726-0.75S11.45,0.337,11.45,0.75v2.176
			C11.45,3.339,11.777,3.676,12.176,3.676z"
            />
            <path
              d="M15.564,3.676c0.398,0,0.725-0.337,0.725-0.75V0.75c0-0.413-0.325-0.75-0.725-0.75c-0.4,0-0.727,0.337-0.727,0.75v2.176
			C14.838,3.339,15.164,3.676,15.564,3.676z"
            />
            <path
              d="M18.949,0c-0.398,0-0.726,0.337-0.726,0.75v2.176c0,0.413,0.326,0.75,0.726,0.75c0.4,0,0.727-0.337,0.727-0.75V0.75
			C19.676,0.337,19.35,0,18.949,0z"
            />
            <path
              d="M5.402,20.676c-0.399,0-0.726,0.337-0.726,0.75v2.176c0,0.413,0.326,0.75,0.726,0.75s0.726-0.337,0.726-0.75v-2.176
			C6.127,21.013,5.801,20.676,5.402,20.676z"
            />
            <path
              d="M8.788,20.676c-0.399,0-0.726,0.337-0.726,0.75v2.176c0,0.413,0.326,0.75,0.726,0.75c0.4,0,0.726-0.337,0.726-0.75v-2.176
			C9.514,21.013,9.188,20.676,8.788,20.676z"
            />
            <path
              d="M12.176,20.676c-0.399,0-0.726,0.337-0.726,0.75v2.176c0,0.413,0.326,0.75,0.726,0.75s0.726-0.337,0.726-0.75v-2.176
			C12.902,21.013,12.575,20.676,12.176,20.676z"
            />
            <path
              d="M15.564,20.676c-0.4,0-0.727,0.337-0.727,0.75v2.176c0,0.413,0.326,0.75,0.727,0.75c0.399,0,0.725-0.337,0.725-0.75
			v-2.176C16.289,21.013,15.963,20.676,15.564,20.676z"
            />
            <path
              d="M18.949,20.676c-0.398,0-0.726,0.337-0.726,0.75v2.176c0,0.413,0.326,0.75,0.726,0.75c0.4,0,0.727-0.337,0.727-0.75
			v-2.176C19.676,21.013,19.35,20.676,18.949,20.676z"
            />
            <path
              d="M2.926,18.225H0.75c-0.413,0-0.75,0.326-0.75,0.727c0,0.399,0.337,0.726,0.75,0.726h2.176c0.412,0,0.75-0.326,0.75-0.726
			C3.676,18.551,3.338,18.225,2.926,18.225z"
            />
            <path
              d="M2.926,14.838H0.75c-0.413,0-0.75,0.326-0.75,0.727c0,0.399,0.337,0.726,0.75,0.726h2.176c0.412,0,0.75-0.326,0.75-0.726
			C3.676,15.164,3.338,14.838,2.926,14.838z"
            />
            <path
              d="M2.926,11.45H0.75C0.337,11.45,0,11.776,0,12.176c0,0.4,0.337,0.727,0.75,0.727h2.176c0.412,0,0.75-0.326,0.75-0.727
			C3.676,11.776,3.338,11.45,2.926,11.45z"
            />
            <path
              d="M2.926,8.063H0.75C0.337,8.063,0,8.389,0,8.789c0,0.4,0.337,0.726,0.75,0.726h2.176c0.412,0,0.75-0.326,0.75-0.726
			C3.676,8.389,3.338,8.063,2.926,8.063z"
            />
            <path
              d="M2.926,4.676H0.75C0.337,4.676,0,5.002,0,5.402s0.337,0.726,0.75,0.726h2.176c0.412,0,0.75-0.326,0.75-0.726
			S3.338,4.676,2.926,4.676z"
            />
            <path
              d="M23.602,18.225h-2.176c-0.412,0-0.75,0.326-0.75,0.727c0,0.399,0.338,0.726,0.75,0.726h2.176
			c0.413,0,0.75-0.326,0.75-0.726C24.352,18.551,24.015,18.225,23.602,18.225z"
            />
            <path
              d="M23.602,14.838h-2.176c-0.412,0-0.75,0.326-0.75,0.727c0,0.399,0.338,0.726,0.75,0.726h2.176
			c0.413,0,0.75-0.326,0.75-0.726C24.352,15.164,24.015,14.838,23.602,14.838z"
            />
            <path
              d="M23.602,11.45h-2.176c-0.412,0-0.75,0.326-0.75,0.726c0,0.4,0.338,0.727,0.75,0.727h2.176c0.413,0,0.75-0.326,0.75-0.727
			C24.352,11.776,24.015,11.45,23.602,11.45z"
            />
            <path
              d="M23.602,8.063h-2.176c-0.412,0-0.75,0.326-0.75,0.726c0,0.4,0.338,0.726,0.75,0.726h2.176c0.413,0,0.75-0.326,0.75-0.726
			C24.352,8.389,24.015,8.063,23.602,8.063z"
            />
            <path
              d="M21.426,6.127h2.176c0.413,0,0.75-0.326,0.75-0.726s-0.337-0.726-0.75-0.726h-2.176c-0.412,0-0.75,0.326-0.75,0.726
			S21.014,6.127,21.426,6.127z"
            />
            <path
              d="M17.676,4.676h-11c-1.1,0-2,0.9-2,2v11c0,1.1,0.9,2,2,2h11c1.1,0,2-0.9,2-2v-11C19.676,5.576,18.775,4.676,17.676,4.676z
			 M16.176,14.176c0,1.1-0.9,2-2,2h-4c-1.1,0-2-0.9-2-2v-4c0-1.1,0.9-2,2-2h4c1.1,0,2,0.9,2,2V14.176z M18.676,18.676h-2.417
			l2.417-2.417V18.676z"
            />
          </g>
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
      </svg>
    );
  if (props.group_id === 10)
    return (
      <svg
        width="36px"
        height="36px"
        viewBox="0 0 36 36"
        className="mr-4 ht-60 wd-60 my-auto primary"
        style={style10}
        version="1.1"
        preserveAspectRatio="xMidYMid meet"
        xmlSpace="preserve"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>process-on-vm-line</title>
        <path
          d="M33.49,26.28a1,1,0,0,0-1.2-.7l-2.49.67a14.23,14.23,0,0,0,2.4-6.75A14.48,14.48,0,0,0,27.37,7.35,1,1,0,0,0,26,7.44a1,1,0,0,0,.09,1.41,12.45,12.45,0,0,1,4.16,10.46,12.19,12.19,0,0,1-2,5.74L28,22.54a1,1,0,1,0-1.95.16l.5,6.44,6.25-1.66A1,1,0,0,0,33.49,26.28Z"
          className="clr-i-outline clr-i-outline-path-1"
        ></path>
        <path
          d="M4.31,17.08a1.06,1.06,0,0,0,.44.16,1,1,0,0,0,1.12-.85A12.21,12.21,0,0,1,18.69,5.84L16.45,7.37a1,1,0,0,0,.47,1.79A1,1,0,0,0,17.56,9l5.33-3.66L18.33.76a1,1,0,1,0-1.39,1.38l1.7,1.7A14.2,14.2,0,0,0,3.89,16.12,1,1,0,0,0,4.31,17.08Z"
          className="clr-i-outline clr-i-outline-path-2"
        ></path>
        <path
          d="M21.73,29.93a12,12,0,0,1-4.84.51,12.3,12.3,0,0,1-9.57-6.3l2.49.93a1,1,0,0,0,.69-1.84l-4.59-1.7h0L4.44,21,3.33,27.35a1,1,0,0,0,.79,1.13l.17,0a1,1,0,0,0,1-.81l.42-2.4a14.3,14.3,0,0,0,11,7.14,13.91,13.91,0,0,0,5.63-.6,1,1,0,0,0-.6-1.9Z"
          className="clr-i-outline clr-i-outline-path-3"
        ></path>
        <path
          d="M22,13H14a1,1,0,0,0-1,1v8a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V14A1,1,0,0,0,22,13Zm-1,8H15V15h6Z"
          className="clr-i-outline clr-i-outline-path-4"
        ></path>
        <rect x="0" y="0" width="36" height="36" fillOpacity={0} />
      </svg>
    );
  if (props.group_id === 7)
    return (
      <svg
        version="1.1"
        id="Capa_1"
        className="mr-4 ht-60 wd-60 my-auto primary"
        style={style7}
        xmlSpace="preserve"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="63.241px"
        height="63.24px"
        viewBox="0 0 63.241 63.24"
      >
        <g>
          <path
            d="M23.011,44.446h7.578v9.479C27.374,50.959,24.827,47.774,23.011,44.446z M30.595,33.352H19.75
c0.176,2.931,0.876,5.842,2.086,8.659h8.759V33.352z M30.595,22.259h-8.989c-1.13,2.805-1.768,5.715-1.879,8.659h10.861v-8.659
H30.595z M11.325,42.011h7.879c-1.101-2.817-1.734-5.726-1.893-8.659h-8.21C9.267,36.386,10.01,39.296,11.325,42.011z
M30.595,9.827c-3.395,3.121-6.031,6.479-7.857,9.996h7.857V9.827z M33.027,30.917H43.89c-0.111-2.944-0.746-5.854-1.88-8.659
h-8.986v8.659H33.027z M33.027,9.827v9.996h7.857C39.057,16.306,36.424,12.947,33.027,9.827z M9.105,30.917h8.186
c0.101-2.937,0.674-5.844,1.705-8.659h-7.673C10.01,24.972,9.267,27.883,9.105,30.917z M27.049,9.897
c-5.902,1.256-11.062,4.819-14.356,9.925h7.328C21.642,16.364,24.006,13.032,27.049,9.897z M33.027,53.925
c3.215-2.964,5.766-6.147,7.576-9.479h-7.576V53.925z M50.932,44.446h-7.587c-1.738,3.522-4.223,6.9-7.4,10.053
C42.116,53.368,47.505,49.759,50.932,44.446z M50.932,19.822c-3.294-5.106-8.458-8.669-14.357-9.925
c3.043,3.132,5.401,6.467,7.032,9.925H50.932z M27.675,54.497c-3.174-3.155-5.662-6.528-7.4-10.053h-7.587
C16.113,49.759,21.504,53.368,27.675,54.497z M52.296,22.259h-7.674c1.031,2.814,1.608,5.722,1.706,8.659h8.185
C54.354,27.883,53.61,24.972,52.296,22.259z M33.027,42.011h8.758c1.211-2.817,1.907-5.729,2.087-8.659H33.027V42.011z
M54.513,33.352h-8.207c-0.155,2.934-0.792,5.842-1.889,8.659h7.879C53.61,39.296,54.354,36.386,54.513,33.352z M59.853,31.618
c0,15.571-12.669,28.242-28.237,28.242c-15.573,0-28.24-12.671-28.24-28.242c0-15.57,12.667-28.237,28.24-28.237
c5.922,0,11.684,1.877,16.46,5.305l-3.332,3.331l12.698,3.31L54.134,2.63l-3.647,3.649C45.056,2.231,38.436,0,31.621,0
C14.184,0,0,14.184,0,31.618C0,49.055,14.184,63.24,31.621,63.24c17.434,0,31.62-14.186,31.62-31.623H59.853z"
          />
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
      </svg>
    );
  if (props.iname === "fav")
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        version="1"
        viewBox="0 0 512 512"
        fill="purple"
        // stroke="blue"
        fillOpacity="0.5"
        // stroke-opacity="0.8"
      >
        <path
          d="M1322 4709c-230-30-410-185-488-419-18-52-19-136-22-1780-2-1235 0-1743 8-1790 20-117 82-199 192-257 47-25 64-28 148-28 79 0 103 4 142 23 28 14 266 218 605 518 307 273 572 504 588 515 34 21 95 25 128 8 12-7 271-233 576-503 304-270 568-501 585-514 47-35 128-55 205-50 126 7 236 81 293 197l23 46 3 1769c2 1951 6 1819-60 1956-40 82-158 203-243 247-137 71-44 67-1400 69-671 1-1248-2-1283-7zm2506-227c107-34 184-102 236-212l21-45V721l-30-31c-16-17-46-35-66-42-32-9-43-8-72 8-20 11-288 242-596 516-338 298-580 505-609 520-40 20-62 23-152 23s-112-3-152-23c-29-15-271-222-609-520-308-274-576-505-596-516-29-16-40-17-72-8-20 7-50 25-66 42l-30 31-3 1735c-2 1683-2 1736 17 1788 41 116 124 199 236 235 58 19 99 20 1272 20 1151 1 1214 0 1271-17z"
          transform="matrix(.1 0 0 -.1 0 512)"
        ></path>
      </svg>
    );
  if (props.iname === "fav2")
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        version="1"
        viewBox="0 0 512 512"
        fill="#8248b8"
        fillOpacity="0.5"
      >
        <path
          d="M1322 4709c-230-30-410-185-488-419-18-52-19-136-22-1780-2-1235 0-1743 8-1790 20-117 82-199 192-257 46-24 64-28 143-28 78 0 97 4 145 27 39 20 219 173 620 531 311 277 574 506 583 510 28 11 86 8 110-4 12-7 55-42 96-78 672-598 1069-943 1109-962 39-20 63-24 142-24 89 0 99 2 158 34 77 42 134 104 164 180l23 56v1760c0 1680-1 1763-18 1820-62 202-213 353-413 412-55 16-147 18-1274 19-668 1-1243-2-1278-7z"
          transform="matrix(.1 0 0 -.1 0 512)"
        ></path>
      </svg>
    );
  return (
    <div>
      <div>icons9</div>
    </div>
  );
};

export default Icons;
